/**
 * @generated SignedSource<<7ca582e7925963d67bae28bdef0809ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewsfeedNative_widgetNewsfeed$data = {
  readonly id: string;
  readonly posts: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNewsfeedPost_widgetNewsfeedPost">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "NewsfeedNative_widgetNewsfeed";
};
export type NewsfeedNative_widgetNewsfeed$key = {
  readonly " $data"?: NewsfeedNative_widgetNewsfeed$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewsfeedNative_widgetNewsfeed">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewsfeedNative_widgetNewsfeed",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNewsfeedPost",
      "kind": "LinkedField",
      "name": "posts",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNewsfeedPost_widgetNewsfeedPost"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetNewsfeed",
  "abstractKey": null
};

(node as any).hash = "7d0c2735665ed90e3a2576752ffb5579";

export default node;
